// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.attribute_kind_enum */
var AttributeKindEnum;
(function (AttributeKindEnum) {
    AttributeKindEnum["SINGLE_NUMBER"] = "SINGLE_NUMBER";
    AttributeKindEnum["INVENTORY_ITEM_REFERENCE"] = "INVENTORY_ITEM_REFERENCE";
    AttributeKindEnum["CHECK"] = "CHECK";
    AttributeKindEnum["TIMESTAMP"] = "TIMESTAMP";
    AttributeKindEnum["DATESTAMP"] = "DATESTAMP";
    AttributeKindEnum["COMPUTED_NUMBER"] = "COMPUTED_NUMBER";
    AttributeKindEnum["TABULAR_DATA"] = "TABULAR_DATA";
    AttributeKindEnum["MEDIA_ATTACHMENT"] = "MEDIA_ATTACHMENT";
    AttributeKindEnum["TEXT"] = "TEXT";
    AttributeKindEnum["INSTRUCTION"] = "INSTRUCTION";
})(AttributeKindEnum || (AttributeKindEnum = {}));
;
export default AttributeKindEnum;
/** Zod schema for attribute_kind_enum */
export const attributeKindEnum = z.nativeEnum(AttributeKindEnum);
//# sourceMappingURL=AttributeKindEnum.js.map